<template>
  <GlobalWindow :title="title" :visible.sync="visible" :confirm-working="isWorking" @confirm="confirm">
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="用户ID" prop="userId"><el-input v-model="form.userId" placeholder="用户ID" /></el-form-item>
      <el-form-item label="日记ID" prop="diaryId"><el-input v-model="form.diaryId" placeholder="日记ID" /></el-form-item>
      <el-form-item label="标题" prop="shareTitle"><el-input v-model="form.shareTitle" placeholder="标题" /></el-form-item>
      <el-form-item label="内容" prop="shareContent"><el-input type="textarea" :rows="3" v-model="form.shareContent" placeholder="内容" /></el-form-item>
      <el-form-item label="金句" prop="aiQuote"><el-input v-model="form.aiQuote" placeholder="金句" /></el-form-item>
      <el-form-item label="发布" prop="isPublished"><el-select v-model="form.isPublished" placeholder="发布">
        <el-option label="0" value="0" />
        <el-option label="1" value="1" />
      </el-select></el-form-item>
    </el-form>
  </GlobalWindow>
</template>
<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'operashareWindow', extends: BaseOpera, components: { GlobalWindow },
  data() { return { form: { id: null, userId: '', diaryId: '', shareTitle: '', shareContent: '', aiQuote: '', isPublished: '' }, rules: {} } },
  created() { this.config({ api: '/rentHouse/share', 'field.id': 'id' }) }
}
</script>